<template>
  <div
    class="fields-group"
    :class="{'no-padding-bottom': noPaddingBottom}"
  >
    <label v-if="label" class="fields-group_label">
      {{ label }}
    </label>
    <div class="fields-group_content">
      <loader v-if="loading" absolute />
      <slot v-else />
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'FieldsGroup',
    components: { Loader },
    props: {
      label: {
        type: String,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      noPaddingBottom: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="less">
.fields-group {
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  position: relative;
  margin-bottom: 50px;

  &.no-padding-bottom {
    padding-bottom: 5px;
  }

  &_label {
    position: absolute;
    top: -10px;
    left: 10px;
    background: #fff;
    padding: 0 5px;
    /*transform: scale(.75);*/
    color: #999;
    font-size: 12px;
  }
  &_content {

  }

}
</style>
